

export default function Terms() {
  return (
    <div className="bg-[var(--t-bg)] min-h-screen text-[var(--t-text)] pt-32 pb-40">
      <div className="max-w-4xl mx-auto px-6">
        <h1 className="text-6xl font-black mb-4 italic uppercase tracking-tighter">
          Terms of <span className="text-transparent bg-clip-text bg-gradient-to-r from-indigo-400 to-purple-400">Service</span>
        </h1>
        <p className="text-[var(--t-text-muted)] font-black uppercase tracking-[0.3em] mb-16 text-xs">Last Updated: May 14, 2026</p>
        
        <div className="prose prose-invert max-w-none space-y-12 text-[var(--t-text-muted)] font-medium leading-relaxed">
          <section className="space-y-6">
            <h2 className="text-2xl font-black text-white italic uppercase tracking-widest">1. Operational Agreement</h2>
            <p>
              By accessing the WholeScale OS infrastructure, you are entering into a binding agreement with the WholeScale Engineering Core. Our platform is designed for elite real estate professionals. If you do not agree to these terms, you are prohibited from utilizing our OS.
            </p>
          </section>

          <section className="space-y-6">
            <h2 className="text-2xl font-black text-white italic uppercase tracking-widest">2. Scope of Infrastructure</h2>
            <p>
              WholeScale OS provides a sovereign environment for lead triage, automated communication, and property data orchestration. We provide the "pipes" and the "intelligence layer"; you are responsible for the content and legality of your operations.
            </p>
          </section>

          <section className="space-y-6">
            <h2 className="text-2xl font-black text-white italic uppercase tracking-widest">3. Commander Accounts</h2>
            <p>
              You are the Commander of your OS instance. You are responsible for maintaining the security of your access keys and team credentials. Any operation executed under your account is deemed your action. We recommend utilizing multi-factor authentication (MFA) via our Supabase integration.
            </p>
          </section>

          <section className="space-y-6">
            <h2 className="text-2xl font-black text-white italic uppercase tracking-widest">4. Conduct of Engagement</h2>
            <p>
              You agree to utilize WholeScale OS in compliance with all local and federal regulations, including but not limited to the TCPA and GDPR. Automated SMS and email transmissions must follow strictly enforced opt-in protocols. WholeScale OS reserves the right to terminate infrastructure access for accounts engaged in predatory or unlawful spam activities.
            </p>
          </section>

          <section className="space-y-6">
            <h2 className="text-2xl font-black text-white italic uppercase tracking-widest">5. Intellectual Property & Sovereignty</h2>
            <p>
              While you maintain 100% sovereignty over your data, WholeScale OS retains all rights, title, and interest in the platform's code, neural architectures, and design tokens. You are granted a limited, non-exclusive license to operate within this framework.
            </p>
          </section>

          <section className="space-y-6">
            <h2 className="text-2xl font-black text-white italic uppercase tracking-widest">6. Limitation of Liability</h2>
            <p>
              Real estate is a high-stakes environment. WholeScale OS shall not be liable for any missed opportunities, data drifts, or infrastructure downtime. We provide our services on an "AS IS" and "AS AVAILABLE" basis. Our total liability for any claim shall not exceed the amount paid by you for the service in the previous 12 months.
            </p>
          </section>

          <section className="space-y-6">
            <h2 className="text-2xl font-black text-white italic uppercase tracking-widest">7. Protocol Updates</h2>
            <p>
              We reserve the right to update these Terms at any time. Your continued use of the OS following the publication of updates constitutes acceptance of the new protocols.
            </p>
          </section>

          <section className="space-y-6">
            <h2 className="text-2xl font-black text-white italic uppercase tracking-widest">8. Support Channel</h2>
            <p>
              For legal inquiries or protocol clarification, contact the WholeScale Engineering Core at: <span className="text-indigo-400 font-black">wholescaleos@gmail.com</span>.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

